import log from '@/logger'
import store from '@/store'

export default (response) => {
  log.info('API - SUCCESS', response.status, response.config.method, response.config.url, response)

  const csrfToken = response.headers['x-csrf-token']

  if (csrfToken) {
    store.dispatch('app/setXCsrfToken', csrfToken)
  } else {
    log.warn('API - SUCCESS', 't.no-x-csrf-token')
  }

  return response
}



// WEBPACK FOOTER //
// ./src/services/interceptors/response-success.js